var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecuredAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8418 5.06348L13.873 5.08398L13.9072 5.10156L17.25 6.82031V7.21777C17.25 11.6191 14.5681 15.564 10.5 17.1943C6.43193 15.564 3.75 11.6191 3.75 7.21777V6.82031L7.09277 5.10156L7.12695 5.08398L7.1582 5.06348L10.5 2.89355L13.8418 5.06348Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.485 7.66051L9.69091 11.4568L7.79182 9.55826",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuredAiIcon);
export default __webpack_public_path__ + "static/media/secured-ai-icon.ad3abe23586395aabaefb5d4764cde0b.svg";
export { ForwardRef as ReactComponent };